import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";

class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      error: "",
      success: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    if (!this.props.match.params.resetString) {
      this.setState({ redirect: 1 });
    } else {
      this.setState({ isLoading: true });
    }

    fetch(
      this.props.url +
        (this.props.isLunda
          ? `/api/lundarundan/user/forgot?resetString=${this.props.match.params.resetString}`
          : `/api/user/forgot?resetString=${this.props.match.params.resetString}`),
      {
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          this.setState({ isLoading: false, show: true });
        } else {
          this.setState({
            error: json.mes,
            success: false,
            isLoading: false,
          });
        }
      });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({ isLoading: true });

    // Post req to backend
    fetch(
      this.props.url +
        (this.props.isLunda
          ? "/api/lundarundan/user/reset/password"
          : "/api/user/reset/password"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password1: e.target.password.value,
          password2: e.target.password2.value,
          resetString: this.props.match.params.resetString,
        }),
      }
    )
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          this.setState({
            error: json.mes,
            success: true,
            showSuccess: true,
            isLoading: false,
          });
        } else {
          this.setState({
            error: json.mes,
            success: false,
            isLoading: false,
          });
        }
      });
  };

  render() {
    return (
      <div id="login" className="noheader">
        {this.state.redirect ? <Redirect to="/" /> : null}
        {this.state.error && <p>{this.state.error}</p>}
        <div className="paymentContainer code">
          {this.state.showSuccess ? (
            <div>
              <h1>Du har ändrat ditt lösenord</h1>

              <Link to="/">
                <button>
                  <p>Tillbaka</p>
                </button>
              </Link>
            </div>
          ) : this.state.show ? (
            <div>
              <h1>Nytt lösenord</h1>
              <div className="loginComponent">
                {!this.state.isLoading ? (
                  <form onSubmit={(e) => this.handleSubmit(e)}>
                    <div className="form">
                      <div className="text-input" id="abId0.12727693608323598">
                        <p className="label">Nytt lösenord</p>
                        <input
                          minLength="6"
                          type="password"
                          placeholder=""
                          name="password"
                        />
                      </div>
                      <div className="text-input" id="abId0.12727693608323598">
                        <p className="label">Bekräfta lösenord</p>
                        <input
                          minLength="6"
                          type="password"
                          placeholder=""
                          name="password2"
                        />
                      </div>
                    </div>
                    <input
                      style={{ marginTop: "40px" }}
                      type="submit"
                      value="Spara"
                    />
                  </form>
                ) : (
                  <div className="sk-circle">
                    <div className="sk-circle1 sk-child"></div>
                    <div className="sk-circle2 sk-child"></div>
                    <div className="sk-circle3 sk-child"></div>
                    <div className="sk-circle4 sk-child"></div>
                    <div className="sk-circle5 sk-child"></div>
                    <div className="sk-circle6 sk-child"></div>
                    <div className="sk-circle7 sk-child"></div>
                    <div className="sk-circle8 sk-child"></div>
                    <div className="sk-circle9 sk-child"></div>
                    <div className="sk-circle10 sk-child"></div>
                    <div className="sk-circle11 sk-child"></div>
                    <div className="sk-circle12 sk-child"></div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <h1>Något gick fel med länken</h1>
              <p>
                Kolla om det finns ett nyare email med återställningslänk eller
                försök skapa en ny återställningslänk.
              </p>
              <p>
                Om det fortfarande inte fungerar så går det att{" "}
                <a
                  href={
                    this.props.isLunda
                      ? "https://lundarundan.se/information.html#kontakt"
                      : "https://branteverest.se/information.html#kontakt"
                  }
                  className="contact"
                  style={{ display: "inline-block" }}
                >
                  <p className="primarylink">Kontakta oss</p>
                </a>
              </p>

              <a
                href={
                  this.props.isLunda
                    ? "https://lundarundan.se/"
                    : "https://branteverest.se"
                }
                style={{ marginTop: 30, alignSelf: "center" }}
              >
                <button>
                  <p>Tillbaka</p>
                </button>
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Reset;
